import React from "react";
import { Limit, Plan } from "../../../../../Entities/Plan";
import { Subscription } from "../../../../../Entities/Subscription";
import { Alert } from "antd";
import { useAppContext } from "../../../../../Context/AppContext/AppContext";

interface CreditPlanInfoProps {
  limits: Limit;
  plan: Plan;
  subscription: Subscription;
  selectedPlanId: string | null;
}

const CreditPlanInfo: React.FC<CreditPlanInfoProps> = ({
  limits,
  plan,
  subscription,
  selectedPlanId,
}) => {
  const { plans } = useAppContext();

  const selectedPlan = plans.find((p) => p._id === selectedPlanId);

  const totalCredits = limits.applicationsProcessed || 0;
  const usedCredits = subscription.measurements.applicationsProcessed || 0;
  const remainingCredits = totalCredits - usedCredits;

  const selectedPlanCredits = selectedPlan?.limits.applicationsProcessed || 0;

  const message = (
    <>
      Your <strong>{remainingCredits}</strong> application credits will be
      carried over. After upgrading, you'll have{" "}
      <strong>{selectedPlanCredits}</strong> plan application credits +{" "}
      <strong>{remainingCredits}</strong> extra application credits.
    </>
  );

  return (
    <Alert
      type="info"
      showIcon
      message={message}
      className="credit-plan-info"
    />
  );
};

export default CreditPlanInfo;
